import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/thumbs-up-green.svg'


const _hoisted_1 = { class: "debit-payment-confirmation content position-relative" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Green Thumbs Up"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerWithBackground = _resolveComponent("LoadingSpinnerWithBackground")!
  const _component_AfterConfirmationAcceptanceScreen = _resolveComponent("AfterConfirmationAcceptanceScreen")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinnerWithBackground, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_AfterConfirmationAcceptanceScreen, { "insured-person-email": _ctx.insuredPersonEmail }, null, 8, ["insured-person-email"])
        ]))
      : _createCommentVNode("", true)
  ]))
}